// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./styles/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/hamburger-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/info-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* bring Notifications über alle Dialog-Overlays */
.k-notification-container,
.k-notification-wrapper {
  position: fixed !important;
  top: 1rem !important;
  right: 1rem !important;
  z-index: 2000 !important; /* höher als das Dialog-Overlay (1000) */
  pointer-events: none; /* Klicks fallen hindurch */
}

.k-notification {
  pointer-events: auto; /* einzelne Notification darf auf Klicks reagieren */
}

.k-button-solid-primary {
  border-color: #ff8200;
  color: white;
  background-color: #ff8200;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}
.k-button-solid-primary:hover {
  background-color: #98a4ae; /* Etwas dunklerer Orange-Ton */
  border-color: #98a4ae; /* Gleicher Farbton wie der Hintergrund im Hover-Zustand */
}

.k-datepicker {
  text-align: left;
}

.k-drawer-item.k-selected {
  color: white;
  background-color: #ff8200;
}
.k-drawer-item.k-selected:hover {
  background-color: #98a4ae; /* Etwas dunklerer Orange-Ton */
  border-color: #98a4ae; /* Gleicher Farbton wie der Hintergrund im Hover-Zustand */
}

.k-dialog-titlebar {
  border-color: inherit;
  color: white;
  background-color: #ff8200;
}

body {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none;
}

.k-drawer-content {
  flex: 1 1 auto;
  background-color: #f0f0f0; /* Hellgrauer Hintergrund */
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
body {
  font-family: "Roboto", sans-serif;
}

h1 {
  font-size: 1.25rem;
  font-weight: 400;
}

h2 {
  font-size: 1rem;
  font-weight: 200;
}

h3 {
  font-size: 1.25rem;
  font-weight: 400;
}

h4 {
  font-size: 1.25rem;
}

h5 {
  font-size: 1.25rem;
}

p {
  font-size: 1rem;
}

a {
  font-size: 1rem;
}

@media (min-width: 480px) {
  h1 {
    font-size: 1.5rem;
    font-weight: 400;
  }
  h2 {
    font-size: 1.25rem;
    font-weight: 200;
  }
}
@media (min-width: 768px) {
  h1 {
    font-size: 1.75rem;
    font-weight: 400;
  }
  h2 {
    font-size: 1.75rem;
    font-weight: 200;
  }
}
body,
h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

.k-grid a.address-link {
  color: #f5811e; /* Orange                  */
  font-size: 0.85rem; /* kleine Schrift          */
  text-decoration: none; /* standard: ohne Unterstr */
}
.k-grid a.address-link:hover {
  text-decoration: underline; /* Unterstrich beim Hover */
}

.k-drawer-container {
  background-color: #D4D6E4;
}
.k-drawer-container .k-drawer {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-right-width: 0 !important;
}
.k-drawer-container.k-drawer-push .k-drawer {
  position: sticky;
  top: 80px;
  height: calc(100vh - 80px);
}
.k-drawer-container .k-drawer-item {
  -webkit-user-select: none;
          user-select: none;
}

.card-container {
  background-color: #FFFFFF;
  padding: 40px 0;
  text-align: center;
}
.card-container.grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  column-gap: 10px;
  row-gap: 1em;
}
.card-container .card-buttons .k-button {
  min-width: 105px;
}
.card-container .card-ranges .k-daterangepicker .k-textbox-container, .card-container .card-ranges .k-daterangepicker .k-floating-label-container {
  padding-top: 0;
  min-width: 105px;
}
.card-container .card-ranges .k-daterangepicker .k-label {
  display: none;
}
.card-container .card-component {
  grid-column: 1/-1;
  overflow: hidden;
}

@media (min-width: 480px) {
  .card-container {
    text-align: initial;
    padding: 30px;
  }
  .card-container.grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .card-container .card-title {
    grid-column: 1/2;
    grid-row: 1;
  }
  .card-container .card-buttons {
    text-align: center;
    grid-column: 1/-1;
    grid-row: 2;
  }
  .card-container .card-ranges {
    text-align: right;
    grid-column: 2/3;
    grid-row: 1;
  }
}
@media (min-width: 768px) {
  .card-container {
    margin: 25px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
  .card-container.grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .card-container .card-buttons {
    text-align: center;
    grid-column: 2/3;
    grid-row: 1;
  }
  .card-container .card-ranges {
    text-align: right;
    grid-column: 3/4;
  }
  .card-container .card-component {
    grid-column-start: 1;
    grid-column-end: -1;
  }
}
.header {
  height: 80px;
  position: sticky;
  top: 0;
  z-index: 3;
}
.header .nav-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  color: #FFFFFF;
}
.header .menu-button {
  flex: 0 0 50px;
  text-align: center;
}
.header .hamburger-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  width: 20px;
  cursor: pointer;
}
.header .title {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 25px;
}
.header .k-avatar {
  display: block;
  width: 40px;
  height: 40px;
  flex-basis: 40px;
  margin: 0 25px;
  box-shadow: 0 0 0px 1px #FFFFFF;
}
.header .settings {
  display: none;
}

@media (min-width: 480px) {
  .header .title {
    flex-direction: row;
    align-items: center;
  }
  .header .vl {
    border-left: 1px solid #FFFFFF;
    height: 25px;
    margin: 6px 15px;
  }
}
@media (min-width: 768px) {
  .header .settings {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
  }
  .header .k-dropdown {
    max-width: 90px;
    margin-left: 15px;
  }
}
.dashboard-page .card-container:last-of-type {
  padding-top: 0;
}
.dashboard-page .k-grid-toolbar .k-textbox {
  margin-bottom: 10px;
}
.dashboard-page .k-grid .k-virtual-content,
.dashboard-page .k-grid .k-virtual-content > div {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.dashboard-page .k-grid .k-virtual-content::-webkit-scrollbar,
.dashboard-page .k-grid .k-virtual-content > div::-webkit-scrollbar {
  display: none;
}
.dashboard-page .k-badge {
  z-index: 1;
}

@media (min-width: 480px) {
  .dashboard-page .k-grid-toolbar .k-textbox {
    margin-bottom: 0;
    float: left;
  }
  .dashboard-page .k-grid-toolbar .k-button {
    float: right;
  }
}
@media (min-width: 768px) {
  .dashboard-page .card-container:last-of-type {
    padding-top: 30px;
  }
}
.planning-page .card-container {
  grid-template-columns: repeat(1, 1fr);
}
.planning-page .card-title {
  grid-column: 1/-1;
}
.planning-page .k-hbox {
  padding: 0 20px;
  background: transparent;
  align-items: center;
}
.planning-page .k-card-title {
  font-size: 15px;
  margin-bottom: -6px;
  text-align: left;
}
.planning-page .k-card-subtitle {
  margin-top: 0;
  text-transform: uppercase;
  font-size: 11px;
}
.planning-page .disabled {
  opacity: 0.5;
}

@media (min-width: 480px) {
  .planning-page .card-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 768px) {
  .planning-page .k-hbox {
    padding: 0;
    border-width: 0;
  }
}
@media (min-width: 960px) {
  .planning-page .card-container {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 1360px) {
  .planning-page .card-container {
    grid-template-columns: repeat(5, 1fr);
  }
}
.profile-page .card-container {
  text-align: left;
}
.profile-page .k-form .k-form-field {
  display: block;
  padding: 0 15px;
}
.profile-page .k-form-field:first-of-type .k-form-field-wrap {
  margin: auto;
}
.profile-page .k-form-field:first-of-type .k-avatar {
  margin: 0 auto 1rem;
}
.profile-page .k-form.k-form-horizontal .k-label {
  width: 100%;
}
.profile-page hr {
  margin-top: 1rem;
  opacity: 0.2;
}
.profile-page .k-form .k-form-buttons {
  justify-content: center;
}
.profile-page .k-form .k-form-buttons > * {
  min-width: 140px;
}

@media (min-width: 480px) {
  .profile-page .k-form .k-form-field {
    display: flex;
  }
  .profile-page .k-form-field:first-of-type .k-avatar {
    margin: 0;
  }
  .profile-page .k-form.k-form-horizontal .k-label {
    width: 25%;
  }
}
@media (min-width: 768px) {
  .profile-page .k-form {
    margin: 0 auto;
    padding: 0;
  }
  .profile-page .k-form .k-form-field {
    padding: 0;
  }
}
.info-page {
  background-color: #151950;
  color: #FFFFFF;
}
.info-page h1, .info-page h2, .info-page h3, .info-page .component-link {
  font-family: Metric, Helvetica, Arial, sans-serif;
}
.info-page a:not(.k-button) {
  color: #71A6FF;
}
.info-page .content {
  padding-top: 40px;
  margin: 0 auto;
  position: relative;
  max-width: 820px;
}
.info-page .kendoka {
  text-align: center;
}
.info-page .kendoka img {
  max-width: 280px;
}
.info-page .section-1 {
  text-align: center;
}
.info-page .section-1 h1 {
  font-size: 48px;
  font-weight: bold;
  color: #53d2fa;
}
.info-page .section-1 h2 {
  font-size: 30px;
  margin-bottom: 53px;
}
.info-page .section-1 .button-group {
  margin-bottom: 30px;
}
.info-page .section-1 .button-group .k-button {
  display: block;
  margin: 10px auto;
  min-width: 145px;
  width: 60%;
}
.info-page .section-1 .github-link {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
}
.info-page .section-1 .github-link .github-text {
  margin-left: 15px;
}
.info-page .section-2 {
  text-align: center;
  margin-top: 40px;
  padding: 0 15px;
}
.info-page .section-3 {
  -webkit-columns: 2;
  column-count: 2;
  margin-top: 40px;
  padding: 0 15px;
}
.info-page .section-3 ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.info-page .package-item {
  display: inline-block;
  margin-top: 20px;
}
.info-page .package-title a {
  font-size: 17px;
  color: #CCCCCC;
  text-transform: uppercase;
}
.info-page .component-link {
  padding: 5px 0;
}
.info-page .component-link a {
  font-size: 20px;
}
.info-page .footer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  height: 320px;
}

@media (min-width: 480px) {
  .info-page .content {
    padding: 40px 40px 0;
  }
  .info-page .kendoka img {
    max-width: 348px;
  }
  .info-page .section-1 h1 {
    font-size: 71px;
  }
  .info-page .section-1 h2 {
    font-size: 38px;
  }
  .info-page .section-1 .button-group .k-button {
    display: inline-block;
    margin-right: 10px;
    width: auto;
  }
  .info-page .section-3 {
    -webkit-columns: 3;
    column-count: 3;
  }
}
@media (max-width: 480px) {
  .k-form-horizontal .k-form-field-wrap {
    max-width: 100%;
  }
}
@media (min-width: 768px) {
  .info-page .content {
    padding: 120px 40px 0;
  }
  .info-page .kendoka {
    position: absolute;
    right: 0;
    top: 2em;
    text-align: left;
  }
  .info-page .section-1,
  .info-page .section-2 {
    text-align: left;
    padding: 0;
  }
  .info-page .section-3 {
    -webkit-columns: 4;
    column-count: 4;
    padding: 0;
  }
  .info-page .footer {
    background-size: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_common.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,kDAAA;AACA;;EAEE,0BAAA;EACA,oBAAA;EACA,sBAAA;EACA,wBAAA,EAAA,wCAAA;EACA,oBAAA,EAAA,2BAAA;AACF;;AAEA;EACE,oBAAA,EAAA,oDAAA;AACF;;AAGA;EACI,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,wEAAA;AAAJ;AAEI;EACI,yBAAA,EAAA,+BAAA;EACA,qBAAA,EAAA,0DAAA;AAAR;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,YAAA;EACA,yBAAA;AADJ;AAEI;EACI,yBAAA,EAAA,+BAAA;EACA,qBAAA,EAAA,0DAAA;AAAR;;AAIA;EACI,qBAAA;EACA,YAAA;EACA,yBAAA;AADJ;;AAIA;EACI,SAAA;EACA,UAAA;EACA,qBAAA;AADJ;;AAMI;;EACI,aAAA;AAFR;;AAMA;EACI,cAAA;EACA,yBAAA,EAAA,2BAAA;AAHJ;;AC3DA;EACI,qBAAA;EACA,+DAAA;AD8DJ;AC5DA;EACI,iCAAA;AD8DJ;;AC3DA;EACI,kBAAA;EACA,gBAAA;AD8DJ;;AC5DA;EACI,eAAA;EACA,gBAAA;AD+DJ;;AC7DA;EACI,kBAAA;EACA,gBAAA;ADgEJ;;AC9DA;EACI,kBAAA;ADiEJ;;AC/DA;EACI,kBAAA;ADkEJ;;AChEA;EACI,eAAA;ADmEJ;;ACjEA;EACI,eAAA;ADoEJ;;ACjEA;EACI;IACI,iBAAA;IACA,gBAAA;EDoEN;EClEE;IACI,kBAAA;IACA,gBAAA;EDoEN;AACF;ACjEA;EACI;IACI,kBAAA;IACA,gBAAA;EDmEN;ECjEE;IACI,kBAAA;IACA,gBAAA;EDmEN;AACF;AEtHA;;;;EAII,SAAA;EACA,UAAA;AFwHJ;;AErHA;EACI,qBAAA;AFwHJ;;AEnHA;EACE,cAAA,EAAA,4BAAA;EACA,kBAAA,EAAA,4BAAA;EACA,qBAAA,EAAA,4BAAA;AFsHF;AEpHE;EACE,0BAAA,EAAA,2BAAA;AFsHJ;;AElHA;EACI,yBCzBe;AH8InB;AEnHI;EACI,uCAAA;EACA,gCAAA;AFqHR;AElHI;EACI,gBAAA;EACA,SAAA;EACA,0BAAA;AFoHR;AEjHI;EACI,yBAAA;UAAA,iBAAA;AFmHR;;AE/GA;EACI,yBCxCI;EDyCJ,eAAA;EACA,kBAAA;AFkHJ;AEhHI;EACI,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,YAAA;AFkHR;AE1GQ;EACI,gBAAA;AF4GZ;AEtGY;EACI,cAAA;EACA,gBAAA;AFwGhB;AErGY;EACI,aAAA;AFuGhB;AElGI;EACI,iBAAA;EACA,gBAAA;AFoGR;;AEhGA;EACI;IACI,mBAAA;IACA,aAAA;EFmGN;EEjGM;IACI,qCAAA;EFmGV;EEhGM;IACI,gBAAA;IACA,WAAA;EFkGV;EE/FM;IACI,kBAAA;IACA,iBAAA;IACA,WAAA;EFiGV;EE9FM;IACI,iBAAA;IACA,gBAAA;IACA,WAAA;EFgGV;AACF;AE3FA;EACI;IACI,YAAA;IACA,kBAAA;IACA,uCAAA;EF6FN;EE3FM;IACI,qCAAA;EF6FV;EEtFM;IACI,kBAAA;IACA,gBAAA;IACA,WAAA;EFwFV;EErFM;IACI,iBAAA;IACA,gBAAA;EFuFV;EEpFM;IACI,oBAAA;IACA,mBAAA;EFsFV;AACF;AEjFA;EACI,YAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AFmFJ;AEjFI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,cC1JA;AH6OR;AEhFI;EACI,cAAA;EACA,kBAAA;AFkFR;AE/EI;EACI,yDAAA;EACA,4BAAA;EACA,WAAA;EACA,eAAA;AFiFR;AE9EI;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AFgFR;AE7EI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;AF+ER;AE5EI;EACI,aAAA;AF8ER;;AE1EA;EAEQ;IACI,mBAAA;IACA,mBAAA;EF4EV;EE1EM;IACI,8BAAA;IACA,YAAA;IACA,gBAAA;EF4EV;AACF;AExEA;EAEQ;IACI,aAAA;IACA,cAAA;IACA,mBAAA;EFyEV;EEtEM;IACI,eAAA;IACA,iBAAA;EFwEV;AACF;AElEI;EACI,cAAA;AFoER;AEjEI;EACI,mBAAA;AFmER;AEhEI;;EAEI,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AFkER;AEjEQ;;EACI,aAAA;AFoEZ;AEhEI;EACI,UAAA;AFkER;;AE5DA;EAEQ;IACI,gBAAA;IACA,WAAA;EF8DV;EE3DM;IACI,YAAA;EF6DV;AACF;AEzDA;EAEQ;IACI,iBAAA;EF0DV;AACF;AErDI;EACI,qCAAA;AFuDR;AErDI;EACI,iBAAA;AFuDR;AErDI;EACI,eAAA;EACA,uBAAA;EACA,mBAAA;AFuDR;AErDI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;AFuDR;AErDI;EACI,aAAA;EACA,yBAAA;EACA,eAAA;AFuDR;AErDI;EACI,YAAA;AFuDR;;AEnDA;EAEQ;IACI,qCAAA;EFqDV;AACF;AEjDA;EAEQ;IACI,UAAA;IACA,eAAA;EFkDV;AACF;AE9CA;EAEQ;IACI,qCAAA;EF+CV;AACF;AE3CA;EAEQ;IACI,qCAAA;EF4CV;AACF;AEtCI;EACI,gBAAA;AFwCR;AErCI;EACI,cAAA;EACA,eAAA;AFuCR;AEpCI;EACI,YAAA;AFsCR;AEnCI;EACI,mBAAA;AFqCR;AElCI;EACI,WAAA;AFoCR;AEjCI;EACI,gBAAA;EACA,YAAA;AFmCR;AEhCI;EACI,uBAAA;AFkCR;AEhCQ;EACI,gBAAA;AFkCZ;;AE7BA;EAEQ;IACI,aAAA;EF+BV;EE5BM;IACI,SAAA;EF8BV;EE3BM;IACI,UAAA;EF6BV;AACF;AEzBC;EAEO;IACI,cAAA;IACA,UAAA;EF0BV;EExBM;IACI,UAAA;EF0BV;AACF;AEpBA;EACI,yBC9Yc;ED+Yd,cC5YI;AHkaR;AEpBI;EACI,iDAAA;AFsBR;AEpBI;EACI,cCnZK;AHyab;AEnBI;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AFqBR;AElBI;EACI,kBAAA;AFoBR;AEnBQ;EACI,gBAAA;AFqBZ;AEjBI;EACI,kBAAA;AFmBR;AElBQ;EACI,eAAA;EACA,iBAAA;EACA,cC1aE;AH8bd;AEjBQ;EACI,eAAA;EACA,mBAAA;AFmBZ;AEhBQ;EACI,mBAAA;AFkBZ;AEhBY;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AFkBhB;AEdQ;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AFgBZ;AEdY;EACI,iBAAA;AFgBhB;AEXI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;AFaR;AEVI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AFYR;AEVQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AFYZ;AERI;EACI,qBAAA;EACA,gBAAA;AFUR;AEPI;EACI,eAAA;EACA,cAAA;EACA,yBAAA;AFSR;AENI;EACI,cAAA;AFQR;AENQ;EACI,eAAA;AFQZ;AEJI;EACI,yDAAA;EACA,4BAAA;EACA,aAAA;AFMR;;AEFA;EAEQ;IACI,oBAAA;EFIV;EEDU;IACI,gBAAA;EFGd;EEEU;IACI,eAAA;EFAd;EEGU;IACI,eAAA;EFDd;EEKc;IACI,qBAAA;IACA,kBAAA;IACA,WAAA;EFHlB;EEOM;IACI,kBAAA;IACA,eAAA;EFLV;AACF;AEQA;EACI;IACI,eAAA;EFNN;AACF;AEUA;EAEQ;IACI,qBAAA;EFTV;EEWM;IACI,kBAAA;IACA,QAAA;IACA,QAAA;IACA,gBAAA;EFTV;EEWM;;IAEI,gBAAA;IACA,UAAA;EFTV;EEWM;IACI,kBAAA;IACA,eAAA;IACA,UAAA;EFTV;EEWM;IACI,sBAAA;EFTV;AACF","sourcesContent":["\r\n/* bring Notifications über alle Dialog-Overlays */\r\n.k-notification-container,\r\n.k-notification-wrapper {\r\n  position: fixed !important;\r\n  top: 1rem !important;\r\n  right: 1rem !important;\r\n  z-index: 2000    !important;  /* höher als das Dialog-Overlay (1000) */\r\n  pointer-events: none;          /* Klicks fallen hindurch */\r\n}\r\n\r\n.k-notification {\r\n  pointer-events: auto;          /* einzelne Notification darf auf Klicks reagieren */\r\n}\r\n\r\n\r\n.k-button-solid-primary {\r\n    border-color: #ff8200;\r\n    color: white;\r\n    background-color: #ff8200;\r\n    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\r\n\r\n    &:hover {\r\n        background-color: #98a4ae; /* Etwas dunklerer Orange-Ton */\r\n        border-color: #98a4ae; /* Gleicher Farbton wie der Hintergrund im Hover-Zustand */\r\n    }\r\n}\r\n\r\n.k-datepicker {\r\n    text-align: left;\r\n}\r\n\r\n.k-drawer-item.k-selected {\r\n    color: white;\r\n    background-color: #ff8200;\r\n    &:hover {\r\n        background-color: #98a4ae; /* Etwas dunklerer Orange-Ton */\r\n        border-color: #98a4ae; /* Gleicher Farbton wie der Hintergrund im Hover-Zustand */\r\n    }\r\n}\r\n\r\n.k-dialog-titlebar {\r\n    border-color: inherit;\r\n    color: white;\r\n    background-color: #ff8200;\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style-type: none;\r\n}\r\n\r\nhtml,\r\nbody {\r\n    &::-webkit-scrollbar {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.k-drawer-content {\r\n    flex: 1 1 auto;\r\n    background-color: #f0f0f0; /* Hellgrauer Hintergrund */\r\n}\r\n\r\n@import \"./styles/main.scss\";\r\n\r\n\r\n","@font-face {\r\n    font-family: \"Roboto\";\r\n    src: url(\"fonts/Roboto-Regular.ttf\") format(\"truetype\");\r\n}\r\nbody {\r\n    font-family: \"Roboto\", sans-serif;\r\n}\r\n\r\nh1 {\r\n    font-size: 1.25rem;\r\n    font-weight: 400;\r\n}\r\nh2 {\r\n    font-size: 1.0rem;;\r\n    font-weight: 200;\r\n}\r\nh3 {\r\n    font-size: 1.25rem;\r\n    font-weight: 400;\r\n}\r\nh4 {\r\n    font-size: 1.25rem;\r\n}\r\nh5 {\r\n    font-size: 1.25rem;\r\n}\r\np {\r\n    font-size: 1rem;\r\n}\r\na {\r\n    font-size: 1rem;\r\n}\r\n\r\n@media (min-width: 480px) {\r\n    h1 {\r\n        font-size: 1.5rem;\r\n        font-weight: 400;\r\n    }\r\n    h2 {\r\n        font-size: 1.25rem;;\r\n        font-weight: 200;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) { \r\n    h1 {\r\n        font-size: 1.75rem;\r\n        font-weight: 400;\r\n    }\r\n    h2 {\r\n        font-size: 1.75rem;;\r\n        font-weight: 200;\r\n    }\r\n}","// Normalization\r\nbody,\r\nh1,\r\nh2,\r\nh3 {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\n// App styles\r\n\r\n.k-grid a.address-link {\r\n  color: #f5811e;          /* Orange                  */\r\n  font-size: 0.85rem;         /* kleine Schrift          */\r\n  text-decoration: none;   /* standard: ohne Unterstr */\r\n\r\n  &:hover {\r\n    text-decoration: underline;   /* Unterstrich beim Hover */\r\n  }\r\n}\r\n\r\n.k-drawer-container {\r\n    background-color: $background-color;\r\n\r\n    .k-drawer {\r\n        box-shadow: 0 0 10px rgba(0,0,0,.2);\r\n        border-right-width: 0 !important;\r\n    }\r\n\r\n    &.k-drawer-push .k-drawer {\r\n        position: sticky;\r\n        top: 80px;\r\n        height: calc(100vh - 80px);\r\n    }\r\n\r\n    .k-drawer-item {\r\n        user-select: none;\r\n    }\r\n}\r\n\r\n.card-container {\r\n    background-color: $white;\r\n    padding: 40px 0;\r\n    text-align: center;\r\n\r\n    &.grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n        column-gap: 10px;\r\n        row-gap: 1em;\r\n    }\r\n\r\n    .card-title {\r\n\r\n    }\r\n\r\n    .card-buttons {\r\n        .k-button {\r\n            min-width: 105px;\r\n        }\r\n    }\r\n\r\n    .card-ranges {\r\n        .k-daterangepicker {\r\n            .k-textbox-container, .k-floating-label-container {\r\n                padding-top: 0; \r\n                min-width: 105px;\r\n            }\r\n\r\n            .k-label {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    .card-component {\r\n        grid-column: 1 / -1;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n@media (min-width: 480px) {\r\n    .card-container {\r\n        text-align: initial;\r\n        padding: 30px;\r\n\r\n        &.grid {\r\n            grid-template-columns: repeat(2, 1fr);\r\n        }\r\n\r\n        .card-title {\r\n            grid-column: 1 / 2;\r\n            grid-row: 1;\r\n        }\r\n\r\n        .card-buttons {\r\n            text-align: center;\r\n            grid-column: 1 / -1;\r\n            grid-row: 2;\r\n        }\r\n\r\n        .card-ranges {\r\n            text-align: right;\r\n            grid-column: 2 / 3;\r\n            grid-row: 1;\r\n        }\r\n    }\r\n\r\n }\r\n\r\n@media (min-width: 768px) { \r\n    .card-container {\r\n        margin: 25px;\r\n        border-radius: 5px;\r\n        box-shadow: 0 0 10px rgba(0,0,0,.2);\r\n\r\n        &.grid {\r\n            grid-template-columns: repeat(3, 1fr);\r\n        }\r\n\r\n        .card-title {\r\n\r\n        }\r\n\r\n        .card-buttons {\r\n            text-align: center;\r\n            grid-column: 2 / 3;\r\n            grid-row: 1;\r\n        }\r\n\r\n        .card-ranges {\r\n            text-align: right;\r\n            grid-column: 3 / 4;\r\n        }\r\n\r\n        .card-component {\r\n            grid-column-start: 1;\r\n            grid-column-end: -1;\r\n        }\r\n    }\r\n}\r\n\r\n// Header\r\n.header {\r\n    height: 80px;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 3;\r\n\r\n    .nav-container {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        height: 100%;\r\n        color: $white;\r\n    }\r\n\r\n    .menu-button {\r\n        flex: 0 0 50px;\r\n        text-align: center;\r\n    }\r\n\r\n    .hamburger-icon {\r\n        background-image:  url('./../assets/hamburger-icon.svg');\r\n        background-repeat: no-repeat;\r\n        width: 20px;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .title {\r\n        display: flex;\r\n        flex: 1 0 auto;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        margin-left: 25px;\r\n    }\r\n\r\n    .k-avatar {\r\n        display: block;\r\n        width: 40px;\r\n        height: 40px;\r\n        flex-basis: 40px;\r\n        margin: 0 25px;\r\n        box-shadow: 0 0 0px 1px $white;\r\n    }\r\n\r\n    .settings {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media (min-width: 480px) {\r\n    .header {\r\n        .title {\r\n            flex-direction: row;\r\n            align-items: center;\r\n        }\r\n        .vl {\r\n            border-left: 1px solid $white;\r\n            height: 25px;\r\n            margin: 6px 15px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .header {\r\n        .settings {\r\n            display: flex;\r\n            flex: 0 0 auto;\r\n            align-items: center;\r\n        }\r\n        \r\n        .k-dropdown {\r\n            max-width: 90px;\r\n            margin-left: 15px;\r\n        }\r\n    }\r\n}\r\n\r\n// Dashboard page\r\n.dashboard-page {\r\n    .card-container:last-of-type {\r\n        padding-top: 0;\r\n    }\r\n\r\n    .k-grid-toolbar .k-textbox {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .k-grid .k-virtual-content,\r\n    .k-grid .k-virtual-content > div {\r\n        -ms-overflow-style: none;  /* IE and Edge */\r\n        scrollbar-width: none;  /* Firefox */\r\n        &::-webkit-scrollbar {\r\n            display: none;\r\n        }\r\n    }\r\n    \r\n    .k-badge {\r\n        z-index: 1\r\n    }\r\n}\r\n\r\n\r\n\r\n@media (min-width: 480px) {\r\n    .dashboard-page {\r\n        .k-grid-toolbar .k-textbox {\r\n            margin-bottom: 0;\r\n            float: left;\r\n        }\r\n    \r\n        .k-grid-toolbar .k-button {\r\n            float: right;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .dashboard-page {\r\n        .card-container:last-of-type {\r\n            padding-top: 30px;\r\n        }\r\n    }\r\n}\r\n// Planning page \r\n.planning-page {\r\n    .card-container {\r\n        grid-template-columns: repeat(1, 1fr);\r\n    }\r\n    .card-title{\r\n        grid-column: 1 / -1;\r\n    }\r\n    .k-hbox {\r\n        padding: 0 20px;\r\n        background: transparent;\r\n        align-items: center;\r\n    }\r\n    .k-card-title {\r\n        font-size: 15px;\r\n        margin-bottom: -6px;\r\n        text-align: left;\r\n    }\r\n    .k-card-subtitle {\r\n        margin-top: 0;\r\n        text-transform: uppercase;\r\n        font-size: 11px;\r\n    }\r\n    .disabled {\r\n        opacity: 0.5;\r\n    }\r\n}\r\n\r\n@media (min-width: 480px) {\r\n    .planning-page {\r\n        .card-container {\r\n            grid-template-columns: repeat(2, 1fr);\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .planning-page {\r\n        .k-hbox {\r\n            padding: 0;\r\n            border-width: 0;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 960px) {\r\n    .planning-page {\r\n        .card-container {\r\n            grid-template-columns: repeat(3, 1fr);\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1360px) {\r\n    .planning-page {\r\n        .card-container {\r\n            grid-template-columns: repeat(5, 1fr);\r\n        }\r\n    }\r\n}\r\n\r\n// Profile page\r\n.profile-page {\r\n    .card-container {\r\n        text-align: left;\r\n    }\r\n\r\n    .k-form .k-form-field {\r\n        display: block;\r\n        padding: 0 15px;\r\n    }\r\n\r\n    .k-form-field:first-of-type .k-form-field-wrap {\r\n        margin: auto;\r\n    }\r\n\r\n    .k-form-field:first-of-type .k-avatar {\r\n        margin: 0 auto 1rem;\r\n    }\r\n\r\n    .k-form.k-form-horizontal .k-label {\r\n        width: 100%;\r\n    }\r\n\r\n    hr {\r\n        margin-top: 1rem;\r\n        opacity: 0.2;\r\n    }\r\n\r\n    .k-form .k-form-buttons {\r\n        justify-content: center;\r\n\r\n        & > * {\r\n            min-width: 140px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 480px) {\r\n    .profile-page {\r\n        .k-form .k-form-field {\r\n            display: flex;\r\n        }\r\n\r\n        .k-form-field:first-of-type .k-avatar {\r\n            margin: 0;\r\n        }\r\n\r\n        .k-form.k-form-horizontal .k-label {\r\n            width: 25%;\r\n        }\r\n    }\r\n}\r\n\r\n @media (min-width: 768px) { \r\n    .profile-page {\r\n        .k-form {\r\n            margin: 0 auto;\r\n            padding: 0;\r\n        }\r\n        .k-form .k-form-field {\r\n            padding: 0;\r\n        }\r\n    }\r\n }\r\n\r\n\r\n// Info page\r\n.info-page {\r\n    background-color: $info-background;\r\n    color: $white;\r\n\r\n    h1, h2, h3, .component-link {\r\n        font-family: Metric,Helvetica,Arial,sans-serif;\r\n    }\r\n    a:not(.k-button) {\r\n        color: $link-color;\r\n    }\r\n    \r\n    .content {\r\n        padding-top: 40px;\r\n        margin: 0 auto;\r\n        position: relative;\r\n        max-width: 820px;\r\n    }\r\n\r\n    .kendoka {\r\n        text-align: center;\r\n        img {\r\n            max-width: 280px;\r\n        }\r\n    }\r\n\r\n    .section-1 {\r\n        text-align: center;\r\n        h1 {\r\n            font-size: 48px;\r\n            font-weight: bold;\r\n            color: $react-color;\r\n        }\r\n\r\n        h2 {\r\n            font-size: 30px;\r\n            margin-bottom: 53px;\r\n        }\r\n\r\n        .button-group {\r\n            margin-bottom: 30px;\r\n\r\n            .k-button {\r\n                display: block;\r\n                margin: 10px auto;\r\n                min-width: 145px;\r\n                width: 60%;\r\n            }\r\n        }\r\n\r\n        .github-link {\r\n            display: inline-flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            align-content: center;\r\n\r\n            .github-text {\r\n                margin-left: 15px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .section-2 {\r\n        text-align: center;\r\n        margin-top: 40px;\r\n        padding: 0 15px;\r\n    }\r\n\r\n    .section-3 {\r\n        -webkit-columns: 2;\r\n        column-count: 2;\r\n        margin-top: 40px;\r\n        padding: 0 15px;\r\n\r\n        ul {\r\n            list-style: none;\r\n            padding: 0;\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    .package-item {\r\n        display: inline-block;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .package-title a {\r\n        font-size: 17px;\r\n        color: #CCCCCC;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .component-link {\r\n        padding: 5px 0;\r\n        \r\n        a {\r\n            font-size: 20px;\r\n        }\r\n    }\r\n\r\n    .footer {\r\n        background-image: url('../assets/info-background.svg');\r\n        background-repeat: no-repeat;\r\n        height: 320px;\r\n    }\r\n}\r\n\r\n@media (min-width: 480px) { \r\n    .info-page {\r\n        .content {\r\n            padding: 40px 40px 0;\r\n        }\r\n        .kendoka {\r\n            img {\r\n                max-width: 348px;\r\n            }\r\n        }\r\n\r\n        .section-1 {\r\n            h1 {\r\n                font-size: 71px;\r\n            }\r\n\r\n            h2 {\r\n                font-size: 38px;\r\n            }\r\n\r\n            .button-group {\r\n                .k-button {\r\n                    display: inline-block;\r\n                    margin-right: 10px;\r\n                    width: auto;\r\n                }\r\n            }\r\n        }\r\n        .section-3 {\r\n            -webkit-columns: 3;\r\n            column-count: 3;\r\n        }\r\n    }\r\n}\r\n@media (max-width: 480px) {\r\n    .k-form-horizontal .k-form-field-wrap {\r\n        max-width: 100%;\r\n    }\r\n    \r\n}\r\n\r\n@media (min-width: 768px) { \r\n    .info-page {\r\n        .content {\r\n            padding: 120px 40px 0;\r\n        }\r\n        .kendoka {\r\n            position: absolute;\r\n            right: 0;\r\n            top: 2em;\r\n            text-align: left;\r\n        }\r\n        .section-1,\r\n        .section-2 {\r\n            text-align: left;\r\n            padding: 0;\r\n        }\r\n        .section-3 {\r\n            -webkit-columns: 4;\r\n            column-count: 4;\r\n            padding: 0;\r\n        }\r\n        .footer {\r\n            background-size: cover;\r\n        }\r\n    }\r\n}","// Global variables here\r\n$background-color: #D4D6E4;\r\n$info-background: #151950;\r\n$react-color: #53d2fa;\r\n$link-color: #71A6FF;\r\n$white: #FFFFFF;\r\n\r\n$tiger-team: #FF6358;\r\n$lemon-team: #FFD246;\r\n$organic-team: #55AB1D;\r\n$ocean-team: #28B4C8;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
